namespace Gamification.Administration {
    export class RoleColumns {
        static columnsKey = 'Administration.Role';
    }
}
